import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function NcertSolutionBioTopics() {
  return (
    <>

      <AllSubjectTopics  subject="biology" type="ncertsolution" />

    </>
  );
}

export default NcertSolutionBioTopics;